import { queryStateToEnglishString, queryStringToQueryState } from '../../../assets/scripts/modules/advanced-search-helpers'
import configuration from './configuration.json'

export const initAdvancedSearch = async (container) => {
  const explanationElement = document.querySelector('[data-query-explanation]')

  if (explanationElement) {
    const queryString = new URLSearchParams(window.location.search).get('advanced-query')

    if (queryString) {
      const explanation = queryStateToEnglishString(queryStringToQueryState(queryString, configuration), configuration)
      explanationElement.innerHTML = explanation
    }
  }
  console.log('init advanced search', container)
  if (!container) {
    console.error('AdvancedSearch: No container provided')
    return
  }

  if (!container.hasAttribute('data-initialized')) {
    container.setAttribute('data-initialized', true)
    const AdvancedSearch = (await import('./components/AdvancedSearch')).default
    AdvancedSearch(container)
  }
}
